import React, { useRef, useEffect } from 'react'
import { HiOutlineArrowRight } from 'react-icons/hi'
import CheckboxGroup from '@/components/common/CheckboxGroup'
import MainCheckBoxGroup from '@/components/common/MainCheckBoxGroup'
import Button from '@/components/common/Button'
import styles from '@/styles/components/speaker.module.scss'
import classNames from 'classnames'

const SpeakerType = ({
  speakerTypes = [],
  isMobileOpen,
  selectedSpeakerTypes,
  selectedSpeakerTypeNames,
  selectedCategories,
  selectedCategoriesNames,
  handleSpeakerTypeChange,
  handleFilterSpeakers,
}) => {
  const divRef = useRef()

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (divRef?.current && !divRef.current.contains(event.target) && !isMobileOpen) {
        if (
          selectedCategories?.length !== selectedCategoriesNames?.length ||
          selectedSpeakerTypes?.length !== selectedSpeakerTypeNames?.length
        ) {
          handleFilterSpeakers && handleFilterSpeakers()
        }
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [handleFilterSpeakers])

  return (
    <>
      <div className="px-5 pt-4 pb-4 overflow-auto md:hidden">
        {speakerTypes?.map((type, index) => {
          return (
            <span key={index}>
              <CheckboxGroup
                name="speakerTypes"
                value={selectedSpeakerTypes}
                onChange={handleSpeakerTypeChange}
              >
                {(Checkbox) => (
                  <div>
                    <li className="flex flex-row-reverse justify-between mb-2 list-none">
                      <Checkbox
                        label={type?.name}
                        value={type?.id}
                        labelClass={
                          'text-xl font-normal leading-loose tracking-wider text-gray-200 hover:text-white'
                        }
                        className={classNames(
                          styles.checkColor,
                          'mt-2 rounded-[0px] opacity-70 mr-2 right-0'
                        )}
                      />
                    </li>
                  </div>
                )}
              </CheckboxGroup>
            </span>
          )
        })}
      </div>
      <div ref={divRef}>
        <div className="hidden gap-2 md:grid md:grid-cols-4 md:px-2">
          {speakerTypes?.map((type, index) => {
            return (
              <div className="text-sm font-normal text-custom-gray-80" key={index}>
                <MainCheckBoxGroup
                  name="speakerTypes"
                  value={selectedSpeakerTypes}
                  onChange={handleSpeakerTypeChange}
                >
                  {(Checkbox) => (
                    <div>
                      <li className="list-none">
                        <Checkbox
                          value={type?.id}
                          label={type?.name}
                          labelClass={`${
                            navigator.userAgent.indexOf('Mac') != -1
                              ? 'bottom-[5px]'
                              : 'bottom-[2px]'
                          } relative ml-2 text-neutral-500 font-sm leading-6 hover:text-white cursor-pointer`}
                          className={classNames(styles.checkColor2, 'rounded-[0px]')}
                        />
                      </li>
                    </div>
                  )}
                </MainCheckBoxGroup>
              </div>
            )
          })}
        </div>
        <div className="hidden w-full mt-10 mb-5 md:border-t border-custom-gray-80 md:block"></div>
        <Button
          className="items-center justify-center hidden px-16 mx-auto my-8 tracking-widest md:flex button-style button-hover group"
          icon={
            <HiOutlineArrowRight className="inline-block w-4 h-5 pb-1 text-white ml-9 group-hover:text-black" />
          }
          label="Filter"
          handleClick={handleFilterSpeakers}
        />
      </div>
    </>
  )
}

export default React.memo(SpeakerType)
